import root from "window-or-global";
import {getLangCode} from "./getLangCode";

export function getLocaleFromUrl() {
    const lang = root.location.pathname.split("/")[1];
    if (!lang) return undefined;
    return root.marketConfig.availableLocales.find(
        (locale) => lang.toLowerCase() === getLangCode(locale),
    );
}
